function useBrowserNotification() {
  const showNotification = (title, options) => {
    if (window.Notification && Notification.permission === "granted") {
      const notification = new Notification(title, options);
      notification.onclick = () => {
        window.focus();
      };
    }
  };

  return showNotification;
}

export default useBrowserNotification;
